import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Input from "@ui/input/Input";
import Panel from "@ui/panel/Panel";
import { Select } from "@ui/select/Select";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import Signal from "badmfck-signal";
import { useState } from "react";
import { CardFeeEntry, CardFeeSection, FEE } from "src/tools/Fee";

export const S_FEE_POPUP = new Signal<{} | null>("S_FEE_POPUP");

//const keys: (keyof typeof FEE)[] = <(keyof typeof FEE)[]>Object.keys(FEE);
declare interface CardType {
	id: CardFeeSection["card_type"];
	label: string;
}

declare interface RegionType {
	id: "domestic" | "intra" | "inter";
	label: string;
}

const cardTypes: CardType[] = [
	{
		id: "mastercard",
		label: "Mastercard",
	},
	{
		id: "visa",
		label: "Visa",
	},
	{
		id: "visa_debit",
		get label() { return msg("visaDebit"); },
	},
];

const regionTypes: RegionType[] = [
	{
		id: "domestic",
		get label() { return msg("domestic"); },
	},
	{
		id: "intra",
		get label() { return msg("intra"); },
	},
	{
		id: "inter",
		get label() { return msg("inter"); },
	},
];

export const FeePopup = () => {
	useLocale();
	const requestData = S_FEE_POPUP.use();

	const [_feeType, setFeeType] = useState<{ id: FEE; label: string }>();
	const [cardType, setCardType] = useState<CardType>(cardTypes[0]);
	const [regionType, setRegionType] = useState<RegionType>(regionTypes[0]);
	const [amount, setAmount] = useState<{ value: string }>({ value: "0" });

	const [feeRule, _setFeeRule] = useState<
		| {
				fee: number;
				description?: string;
				rule: CardFeeEntry;
		  }
		| undefined
		| null
	>(null);

	// const feeTypes = useMemo(() => {
	// 	return Object.keys(FEE).map(k => {
	// 		return { id: k as FEE, label: FEE[k as keyof typeof FEE] };
	// 	});
	// }, []);

	// useEffect(() => {
	// 	if (feeType && cardType && !Number.isNaN(amount.value)) {
	// 		const fee:
	// 			| {
	// 					fee: number;
	// 					description?: string;
	// 					rule: CardFeeEntry;
	// 			  }
	// 			| undefined = calculate({
	// 			amount: parseFloat(amount.value),
	// 			cardType: cardType.id,
	// 			feeType: feeType.id,
	// 			region: regionType.id,
	// 		});

	// 		setFeeRule(fee);
	// 	} else {
	// 		setFeeRule(null);
	// 	}
	// }, [amount, feeType, cardType, regionType]);

	if (!requestData) return null;

	const closePopup = () => {
		setFeeType(undefined);
		setCardType(cardTypes[0]);
		setRegionType(regionTypes[0]);
		setAmount({ value: "0" });
		S_FEE_POPUP.invoke(null);
	};

	return (
		<Panel
			sx={{
				minWidth: "600px",
				// width: "85vw",
				height: "85vh",
				padding: "0",

				// minWidth: "500px",
			}}
			decorator="absolute"
			label={msg("feeInterchange")}
			onClose={closePopup}>
			<VBox gap="12px">
				<Input
					label={msg("amount")}
					onChange={v => {
						setAmount({ value: v });
					}}
					data={amount}
					name="value"
					units="EUR"
				/>

				{/* <Select
					label="Fee type"
					sheetAlign="left"
					onChange={e => {
						setFeeType(e);
					}}
					value={feeType}
					values={feeTypes}
				/> */}

				<HBox gap="12px" sx={{ width: "100%" }}>
					<Box sx={{ display: "flex", flex: 1, "&>div": { width: "100%" } }}>
						<Select
							label={msg("cardSystem")}
							sheetAlign="left"
							onChange={e => {
								setCardType(e);
							}}
							value={cardType}
							values={cardTypes}
						/>
					</Box>
					<Box sx={{ display: "flex", flex: 1, "&>div": { width: "100%" } }}>
						<Select
							label={msg("transactionRegion")}
							sheetAlign="left"
							onChange={e => {
								setRegionType(e);
							}}
							value={regionType}
							values={regionTypes}
						/>
					</Box>
				</HBox>
			</VBox>

			{feeRule && (
				<>
					<Spacer size="20px" />

					<VBox gap="8px" sx={{ backgroundColor: "#e7e7e7", padding: "12px 16px", borderRadius: "8px" }}>
						<HBox gap="10px">
							<Typo bold variant="headMedium">{msg("fee_81a5eda2")}</Typo>
							<Typo bold variant="headMedium">
								{feeRule.fee} {feeRule.rule.currency ? feeRule.rule.currency : "EUR"}
							</Typo>

							{feeRule.rule.additionalPercent && <Typo>+{feeRule.rule.additionalPercent}%</Typo>}
						</HBox>

						<HBox gap="10px">
							<Typo variant="medium">{msg("feeRate")}</Typo>
							<Typo variant="medium">
								{feeRule.rule.value} {feeRule.rule.isPercent ? "%" : feeRule.rule.currency ? feeRule.rule.currency : "EUR"}
							</Typo>

							{feeRule.rule.additionalPercent && <Typo>+{feeRule.rule.additionalPercent}%</Typo>}
						</HBox>

						{feeRule.rule.maxValue !== undefined && (
							<Typo variant="medium" sx={{ maxWidth: "500px" }}>{msg("max")}{feeRule.rule.maxValue} {feeRule.rule.currency ? feeRule.rule.currency : "EUR"}
							</Typo>
						)}

						{feeRule.description && (
							<Typo variant="medium" sx={{ maxWidth: "500px" }}>{msg("feeDescription")}{feeRule.description}
							</Typo>
						)}
					</VBox>
					<Spacer size="30px" />
				</>
			)}
			{feeRule === undefined && (
				<>
					<Spacer size="20px" />
					<VBox sx={{ backgroundColor: "#e4c0c0", padding: "12px", borderRadius: "8px" }}>
						<Typo sx={{ maxWidth: "500px" }}>{msg("noFeeMatchedFound")}</Typo>
					</VBox>
					<Spacer size="40px" />
				</>
			)}

			<Spacer grow />
			<VBox sx={{ gap: "12px", width: "100%" }}>
				<HBox gap="12px" sx={{ width: "100%" }}>
					<Button
						sx={{ flex: 1 }}
						title={msg("close")}
						onClick={() => {
							closePopup();
						}}
					/>
				</HBox>
			</VBox>
		</Panel>
	);
};
